import React, { Fragment } from 'react';
import { Form } from 'react-bootstrap';

const WidgetFieldOptions = ({ element, register }) => {
    return (
        <Fragment>
            {element.key === 'InputField' && (
                <Fragment>
                    <Form.Group
                        controlId="maxLengthInput"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Form.Label style={{ marginRight: '10px', marginBottom: '0' }}>
                            Maximum characters allowed:
                        </Form.Label>
                        <Form.Control
                            type="number"
                            placeholder=""
                            defaultValue={(element?.options || {})?.maxLength}
                            name="options.maxLength"
                            ref={register}
                            onWheel={(event) => event.currentTarget.blur()}
                            min={0}
                            style={{ width: '300px' }}
                        />
                    </Form.Group>
                </Fragment>
            )}
        </Fragment>
    );
};

export default WidgetFieldOptions;
